// src/services/authService.js
import globals from "@/globalVariables";

export const saveTokenToSubDomain = async (accessToken, refreshToken) => {
    const message = {
        accessToken,
        refreshToken
    }
    const ifram = document.getElementById('extFrame');
    const wind = ifram.contentWindow;
    wind.postMessage(JSON.stringify(message), globals.roomDomain);
    setTimeout(function () {
        wind.postMessage(JSON.stringify(message), globals.roomDomain);
    }, 2000);
    console.log("accessToken, refreshToken ", accessToken, refreshToken )
    return { accessToken, refreshToken };
};
